import React from "react";
import UserThinkingChart from "./UserThinkingChart";
import UserAnsweringChart from "./UserAnsweringChart";
import MergedChart from "./MergedChart";
import BarGraph from "./answerAnalytics/BarGraph";
import KeyTakeaways from "./answerAnalytics/KeyTakeaways";
import { Tabs } from "antd";

const AnswerAnalysis = ({
  interviewAnalysisIntegrityData,
  updateVideoTrack,
  jdLevelData,
}) => {
  const items = [
    {
      key: "1",
      label: "Individual graphs",
      children: (
        <>
          <UserThinkingChart
            dataPoints={interviewAnalysisIntegrityData?.thinkingTimingList}
            anwerDataPoints={interviewAnalysisIntegrityData?.answerTimingList}
            updateVideoTrack={updateVideoTrack}
            jdAvgThinkingTime={jdLevelData?.avgThinkingTime}
            minThinkingTime={
              interviewAnalysisIntegrityData?.timingSummary?.minThinkingTime
            }
            maxThinkingTime={
              interviewAnalysisIntegrityData?.timingSummary?.maxThinkingTime
            }
            avgThinkingTime={
              interviewAnalysisIntegrityData?.timingSummary?.avgThinkingTime
            }
            avgAnswerTime={
              interviewAnalysisIntegrityData?.timingSummary?.avgAnswerTime
            }
            jdAvgTime={jdLevelData?.avgAnswerTime}
          />
          <div className="mt-12" />
          <UserAnsweringChart
            dataPoints={interviewAnalysisIntegrityData?.answerTimingList}
            updateVideoTrack={updateVideoTrack}
            minAnswerTime={
              interviewAnalysisIntegrityData?.timingSummary?.minAnswerTime
            }
            maxAnswerTime={
              interviewAnalysisIntegrityData?.timingSummary?.maxAnswerTime
            }
            avgAnswerTime={
              interviewAnalysisIntegrityData?.timingSummary?.avgAnswerTime
            }
            jdAvgTime={jdLevelData?.avgAnswerTime}
          />
        </>
      ),
    },

    {
      key: "2",
      label: "Merged Graph",
      children: (
        <MergedChart
          dataPoints={interviewAnalysisIntegrityData?.thinkingTimingList}
          anwerDataPoints={interviewAnalysisIntegrityData?.answerTimingList}
          updateVideoTrack={updateVideoTrack}
          jdAvgThinkingTime={jdLevelData?.avgThinkingTime}
          minThinkingTime={
            interviewAnalysisIntegrityData?.timingSummary?.minThinkingTime
          }
          maxThinkingTime={
            interviewAnalysisIntegrityData?.timingSummary?.maxThinkingTime
          }
          avgThinkingTime={
            interviewAnalysisIntegrityData?.timingSummary?.avgThinkingTime
          }
          avgAnswerTime={
            interviewAnalysisIntegrityData?.timingSummary?.avgAnswerTime
          }
          minAnswerTime={
            interviewAnalysisIntegrityData?.timingSummary?.minAnswerTime
          }
          maxAnswerTime={
            interviewAnalysisIntegrityData?.timingSummary?.maxAnswerTime
          }
          jdAvgTime={jdLevelData?.avgAnswerTime}
        />
      ),
    },
  ];
  return (
    <>
      <Tabs type="card" animated defaultActiveKey="1" items={items} />

      {/* <p className="text-[.9rem] text-gray-600 font-normal px-2 mt-4">
        <span className="text-red-500 underline font-semibold">Note:</span>{" "}
        <span className="text-black font-bold">User Thinking Time</span> is
        calculated differently based on the selected mode.{" "}
        <span className="text-black font-bold">In Hands-free Mode</span>, it is
        measured from when Maya stops speaking to when the user begins speaking.{" "}
        <span className="text-black font-bold">In Manual Mode</span>, it is
        measured from when Maya stops speaking to when the user clicks the
        “Start Answering” button. Please note that this measurement may not be
        perfectly accurate.
      </p> */}
      <BarGraph
        jdLevelAnalytics={jdLevelData}
        userAnalytics={interviewAnalysisIntegrityData?.timingSummary}
        userThinkingDataPoints={interviewAnalysisIntegrityData?.thinkingTimingList}
        userAnwerDataPoints={interviewAnalysisIntegrityData?.answerTimingList}
      />
      <KeyTakeaways
        jdLevelAnalytics={jdLevelData}
        userAnalytics={interviewAnalysisIntegrityData?.timingSummary}
      />
    </>
  );
};

export default AnswerAnalysis;
